import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { FOOTBALL_IDENTIFIER, NFL_IDENTIFIER } from '../Sport/Sport';

const getFootballPeriod = (intl, inputValue) => {
  const displayValues = [
    {
      apiValue: '1',
      display: intl.formatMessage({
        defaultMessage: '1st Half',
        id: 'fc995',
      }),
    },
    {
      apiValue: '2',
      display: intl.formatMessage({
        defaultMessage: '2nd Half',
        id: '8b0f3',
      }),
    },
    {
      apiValue: '3',
      display: intl.formatMessage({
        defaultMessage: 'Extra Time 1',
        id: 'e34a5',
      }),
    },
    {
      apiValue: '4',
      display: intl.formatMessage({
        defaultMessage: 'Extra Time 2',
        id: 'bff88',
      }),
    },
    {
      apiValue: '5',
      display: intl.formatMessage({
        defaultMessage: 'Penalties',
        id: '6bf4b',
      }),
    },
  ];
  return displayValues.find(
    (period) => period.apiValue === inputValue.toString(),
  )?.display;
};

const getOvertimeDisplayValue = (intl, overtimeNumber) =>
  intl.formatMessage(
    {
      defaultMessage: 'Overtime {overtimeNumber}',
      id: '5970c',
    },
    {
      overtimeNumber,
    },
  );

const getNFLPeriod = (intl, inputValue) => {
  const displayValues = [
    {
      apiValue: '1',
      display: intl.formatMessage({
        defaultMessage: '1st Quarter',
        id: 'bab80',
      }),
    },
    {
      apiValue: '2',
      display: intl.formatMessage({
        defaultMessage: '2nd Quarter',
        id: 'f728b',
      }),
    },
    {
      apiValue: '3',
      display: intl.formatMessage({
        defaultMessage: '3rd Quarter',
        id: '0388a',
      }),
    },
    {
      apiValue: '4',
      display: intl.formatMessage({
        defaultMessage: '4th Quarter',
        id: '1250c',
      }),
    },
    {
      apiValue: '5',
      display: intl.formatMessage({
        defaultMessage: 'Overtime',
        id: 'd8553',
      }),
    },
    {
      apiValue: '6',
      display: getOvertimeDisplayValue(intl, 2),
    },
    {
      apiValue: '7',
      display: getOvertimeDisplayValue(intl, 3),
    },
    {
      apiValue: '8',
      display: getOvertimeDisplayValue(intl, 4),
    },
    {
      apiValue: '9',
      display: getOvertimeDisplayValue(intl, 5),
    },
    {
      apiValue: '10',
      display: getOvertimeDisplayValue(intl, 6),
    },
    {
      apiValue: '11',
      display: getOvertimeDisplayValue(intl, 7),
    },
    {
      apiValue: '12',
      display: getOvertimeDisplayValue(intl, 8),
    },
    {
      apiValue: '13',
      display: getOvertimeDisplayValue(intl, 9),
    },
  ];
  return displayValues.find(
    (period) => period.apiValue === inputValue.toString(),
  )?.display;
};

export const findPeriodDisplayValue = (intl, inputValue, sport) => {
  const valueWhenUnknown = intl.formatMessage({
    defaultMessage: 'Not Provided',
    id: '99817',
  });
  if (inputValue) {
    if (FOOTBALL_IDENTIFIER === sport) {
      return getFootballPeriod(intl, inputValue) || valueWhenUnknown;
    }
    if (NFL_IDENTIFIER === sport) {
      return getNFLPeriod(intl, inputValue) || valueWhenUnknown;
    }
    return inputValue;
  }
  return valueWhenUnknown;
};

export function Period({ period, sport }) {
  return findPeriodDisplayValue(useIntl(), period, sport);
}

Period.propTypes = {
  period: PropTypes.oneOfType([(PropTypes.string, PropTypes.number)]),
  sport: PropTypes.string,
};
Period.propTypes = {
  period: '',
  sport: '',
};

export default Period;
